module.exports = __webpack_public_path__ + "img/img_incruit.df4286de.jpg";